<div class="page-head">
  <div>
    <p class="eyebrow">การจัดการทัวร์</p>
    <h1>รายการทัวร์</h1>
    <p>รวมทัวร์บริษัทสำหรับจัดการ Booking ค่าใช้จ่าย และการเบิกระดับทัวร์</p>
  </div>
  <div class="flex flex-wrap items-center gap-2">
    @if (canManageTours()) {
      <button
        type="button"
        class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 active:scale-[0.98]"
        (click)="openCreateModal()"
      >
        <lucide-icon name="Plus" [size]="17" />
        สร้างทัวร์
      </button>
    }
  </div>
</div>

@if (isCreateModalOpen()) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeCreateModal()"
  >
    <section
      class="my-auto w-full max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tour-form-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            ข้อมูลทัวร์บริษัท
          </p>
          <h2 id="tour-form-title" class="m-0 text-xl font-bold text-slate-800">
            {{ editingTourId() ? 'แก้ไขทัวร์บริษัท' : 'สร้างทัวร์บริษัทใหม่' }}
          </h2>
          <p class="mt-1 mb-0 text-sm text-slate-500">
            {{
              editingTourId()
                ? 'แก้ไขข้อมูลทัวร์ ราคา เอกสาร และรายการค่าใช้จ่าย'
                : 'กรอกข้อมูลทัวร์ ราคา เอกสาร และรายละเอียดก่อนเพิ่ม Booking เข้ามาร่วมทัวร์'
            }}
          </p>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeCreateModal()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>

      <form [formGroup]="tourForm" (ngSubmit)="saveTour()">
        <div class="max-h-[68vh] space-y-5 overflow-y-auto px-5 py-5 sm:px-6">
          <section class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 sm:p-5">
            <div class="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
              <span class="grid size-9 place-items-center rounded-lg bg-sky-100 text-sky-700"
                ><lucide-icon name="BriefcaseBusiness" [size]="18"
              /></span>
              <div>
                <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลทัวร์และรายละเอียด</h3>
                <p class="m-0 text-xs text-slate-500">
                  ข้อมูลหลัก เอกสาร และรายละเอียดสำหรับสร้างรายการทัวร์บริษัท
                </p>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>รหัสทัวร์ <span class="text-red-500">*</span></span
                ><input
                  pInputText
                  formControlName="tourCode"
                  class="h-11 w-full font-normal"
                  placeholder="เช่น JP-260420"
                />
                @if (tourForm.controls.tourCode.touched && tourForm.controls.tourCode.invalid) {
                  <small class="font-normal text-red-600">{{
                    tourForm.controls.tourCode.hasError('maxlength')
                      ? 'รหัสทัวร์ต้องไม่เกิน 30 ตัวอักษร'
                      : 'กรุณากรอกรหัสทัวร์'
                  }}</small>
                }
              </label>
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>ประเภททัวร์ <span class="text-red-500">*</span></span
                ><p-select
                  class="h-11 w-full font-normal"
                  formControlName="tourType"
                  (onChange)="onTourTypeChange()"
                  [options]="tourTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="เลือกประเภททัวร์"
                />
                @if (tourForm.controls.tourType.touched && tourForm.controls.tourType.invalid) {
                  <small class="font-normal text-red-600">กรุณาเลือกประเภททัวร์</small>
                }
              </label>
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>ชื่อทัวร์ <span class="text-red-500">*</span></span
                ><input
                  pInputText
                  formControlName="tourName"
                  class="h-11 w-full font-normal"
                  placeholder="เช่น โตเกียว ฟูจิ 5 วัน"
                />
                @if (tourForm.controls.tourName.touched && tourForm.controls.tourName.invalid) {
                  <small class="font-normal text-red-600">{{
                    tourForm.controls.tourName.hasError('maxlength')
                      ? 'ชื่อทัวร์ต้องไม่เกิน 200 ตัวอักษร'
                      : 'กรุณากรอกชื่อทัวร์'
                  }}</small>
                }
              </label>
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>ประเทศ <span class="text-red-500">*</span></span
                ><p-select
                  class="h-11 w-full font-normal"
                  formControlName="country"
                  [options]="countryOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="เลือกประเทศ"
                  [filter]="true"
                  filterBy="label"
                />
                @if (tourForm.controls.country.touched && tourForm.controls.country.invalid) {
                  <small class="font-normal text-red-600">กรุณาเลือกประเทศ</small>
                }
              </label>
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>วันเดินทาง <span class="text-red-500">*</span></span
                ><p-datepicker
                  class="h-11 w-full font-normal"
                  formControlName="travelDate"
                  dateFormat="dd/mm/yy"
                  placeholder="เลือกวันเดินทางไป"
                  [showIcon]="true"
                  [readonlyInput]="true"
                  appendTo="body"
                />
                @if (tourForm.controls.travelDate.touched && tourForm.controls.travelDate.invalid) {
                  <small class="font-normal text-red-600">กรุณาเลือกวันเดินทาง</small>
                }
              </label>
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>วันเดินทางกลับ</span
                ><p-datepicker
                  class="h-11 w-full font-normal"
                  formControlName="returnDate"
                  dateFormat="dd/mm/yy"
                  placeholder="เลือกวันเดินทางกลับ"
                  [showIcon]="true"
                  [readonlyInput]="true"
                  appendTo="body"
              /></label>
              <label
                class="grid content-start gap-1 text-sm font-semibold text-slate-700 md:col-span-2"
                ><span>จำนวนคนเป้าหมาย <span class="text-red-500">*</span></span
                ><p-inputnumber
                  class="w-full font-normal"
                  inputStyleClass="h-11 w-full"
                  formControlName="requiredPax"
                  [min]="0"
                  [maxFractionDigits]="0"
                  [showButtons]="true"
                  buttonLayout="horizontal"
                  placeholder="เช่น 20"
                />
                @if (
                  tourForm.controls.requiredPax.touched && tourForm.controls.requiredPax.invalid
                ) {
                  <small class="font-normal text-red-600">{{
                    tourForm.controls.requiredPax.hasError('required')
                      ? 'กรุณาระบุจำนวนคนเป้าหมาย'
                      : 'จำนวนคนเป้าหมายต้องมากกว่า 0'
                  }}</small>
                }
              </label>
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>ราคาทัวร์ต่อคน <span class="text-red-500">*</span></span
                ><p-inputnumber
                  class="w-full font-normal"
                  inputStyleClass="h-11 w-full"
                  formControlName="tourPrice"
                  mode="currency"
                  currency="THB"
                  locale="th-TH"
                  [min]="0"
                  placeholder="เช่น 25,000"
                />
                @if (tourForm.controls.tourPrice.touched && tourForm.controls.tourPrice.invalid) {
                  <small class="font-normal text-red-600">{{
                    tourForm.controls.tourPrice.hasError('required')
                      ? 'กรุณาระบุราคาทัวร์ต่อคน'
                      : 'ราคาทัวร์ต่อคนต้องมากกว่า 0 บาท'
                  }}</small>
                }
              </label>
              <div class="grid content-start gap-1 text-sm font-semibold text-slate-700">
                <span>รูปโปรไฟล์ทัวร์</span>
                <div class="rounded-xl border border-dashed border-slate-300 bg-white p-3">
                  <div class="flex flex-wrap items-center gap-2">
                    <p-fileupload
                      #profileUpload
                      mode="basic"
                      name="tourProfile"
                      chooseLabel="เลือกไฟล์รูป"
                      accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                      [maxFileSize]="5000000"
                      [auto]="false"
                      (onSelect)="selectProfileFile($event)"
                      (onClear)="clearProfileFile()"
                    /><button
                      type="button"
                      class="tw-button inline-flex h-10 items-center rounded-lg border border-red-200 bg-white px-3 text-sm font-semibold text-red-600 disabled:opacity-40"
                      [disabled]="!profileFileName()"
                      (click)="profileUpload.clear(); clearProfileFile()"
                    >
                      ล้างไฟล์
                    </button>
                  </div>
                  @if (profileFileName()) {
                    <p class="mt-2 mb-0 text-xs font-normal text-sky-700">
                      {{ profileFileName() }}
                    </p>
                  }
                  @if (editingTourId() && existingProfilePath(); as oldPath) {
                    <a
                      [href]="tourImageUrl(existingProfilePath())"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="mt-2 inline-flex h-9 items-center justify-center gap-2 rounded-lg border border-sky-200 bg-white px-3 text-xs font-semibold text-sky-700 no-underline transition hover:bg-sky-50 hover:text-sky-900"
                      ><lucide-icon
                        name="ExternalLink"
                        [size]="15"
                        aria-hidden="true"
                      />ดูไฟล์เดิม</a
                    >
                  }
                  <p class="mt-2 mb-0 text-xs font-normal text-slate-500">
                    รองรับ JPG, PNG ขนาดไม่เกิน 5 MB
                  </p>
                </div>
              </div>
              <div class="grid content-start gap-1 text-sm font-semibold text-slate-700">
                <span>ไฟล์รายละเอียดทัวร์ PDF</span>
                <div class="rounded-xl border border-dashed border-slate-300 bg-white p-3">
                  <div class="flex flex-wrap items-center gap-2">
                    <p-fileupload
                      #tourPdfUpload
                      mode="basic"
                      name="tourPdfDetail"
                      chooseLabel="เลือกไฟล์ PDF"
                      accept="application/pdf"
                      [maxFileSize]="10000000"
                      [auto]="false"
                      (onSelect)="selectTourPdfFile($event)"
                      (onClear)="clearTourPdfFile()"
                    /><button
                      type="button"
                      class="tw-button inline-flex h-10 items-center rounded-lg border border-red-200 bg-white px-3 text-sm font-semibold text-red-600 disabled:opacity-40"
                      [disabled]="!tourPdfFileName()"
                      (click)="tourPdfUpload.clear(); clearTourPdfFile()"
                    >
                      ล้างไฟล์
                    </button>
                  </div>
                  @if (tourPdfFileName()) {
                    <p class="mt-2 mb-0 text-xs font-normal text-sky-700">
                      {{ tourPdfFileName() }}
                    </p>
                  }
                  @if (editingTourId() && existingTourPdfPath(); as oldPath) {
                    <a
                      [href]="tourImageUrl(existingTourPdfPath())"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="mt-2 inline-flex h-9 items-center justify-center gap-2 rounded-lg border border-sky-200 bg-white px-3 text-xs font-semibold text-sky-700 no-underline transition hover:bg-sky-50 hover:text-sky-900"
                      ><lucide-icon
                        name="ExternalLink"
                        [size]="15"
                        aria-hidden="true"
                      />ดูไฟล์เดิม</a
                    >
                  }
                  <p class="mt-2 mb-0 text-xs font-normal text-slate-500">
                    รองรับ PDF ขนาดไม่เกิน 10 MB
                  </p>
                </div>
              </div>
              <label
                class="grid content-start gap-1 text-sm font-semibold text-slate-700 md:col-span-2"
                ><span>รายละเอียดโปรแกรม</span
                ><textarea
                  pTextarea
                  formControlName="programDetail"
                  rows="4"
                  class="w-full resize-y font-normal"
                  placeholder="รายละเอียดโปรแกรม โรงแรม และการเดินทาง"
                ></textarea>
                @if (
                  tourForm.controls.programDetail.touched &&
                  tourForm.controls.programDetail.hasError('maxlength')
                ) {
                  <small class="font-normal text-red-600"
                    >รายละเอียดโปรแกรมต้องไม่เกิน 5,000 ตัวอักษร</small
                  >
                }
              </label>
              <label
                class="grid content-start gap-1 text-sm font-semibold text-slate-700 md:col-span-2"
                ><span>หมายเหตุ</span
                ><textarea
                  pTextarea
                  formControlName="note"
                  rows="3"
                  class="w-full resize-y font-normal"
                  placeholder="หมายเหตุเพิ่มเติม"
                ></textarea>
                @if (
                  tourForm.controls.note.touched && tourForm.controls.note.hasError('maxlength')
                ) {
                  <small class="font-normal text-red-600">หมายเหตุต้องไม่เกิน 1,000 ตัวอักษร</small>
                }
              </label>
            </div>
          </section>

          <section class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 sm:p-5">
            <div class="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
              <span
                class="grid size-9 place-items-center rounded-lg bg-emerald-100 text-emerald-700"
                ><lucide-icon name="CircleDollarSign" [size]="18"
              /></span>
              <div>
                <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลคอมมิชชั่น</h3>
                <p class="m-0 text-xs text-slate-500">
                  @if (tourForm.controls.tourType.value === 'GROUP_TOUR') {
                    คอมผู้ดูแลทัวร์เป็นเปอร์เซ็นต์
                  } @else {
                    คอม Sale เป็นบาท และคอมผู้ดูแลทัวร์เป็นเปอร์เซ็นต์
                  }
                </p>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
              @if (tourForm.controls.tourType.value !== 'GROUP_TOUR') {
                <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                  ><span>คอม Sale ต่อคน (บาท) <span class="text-red-500">*</span></span
                  ><p-inputnumber
                    class="w-full font-normal"
                    inputStyleClass="h-11 w-full"
                    formControlName="saleCommission"
                    mode="currency"
                    currency="THB"
                    locale="th-TH"
                    [min]="0"
                    placeholder="0"
                  />
                  @if (
                    tourForm.controls.saleCommission.touched &&
                    tourForm.controls.saleCommission.invalid
                  ) {
                    <small class="font-normal text-red-600">{{
                      tourForm.controls.saleCommission.hasError('required')
                        ? 'กรุณาระบุคอม Sale'
                        : 'คอม Sale ต้องไม่ติดลบ'
                    }}</small>
                  }
                </label>
              }
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                ><span>คอมผู้ดูแลทัวร์ (%) <span class="text-red-500">*</span></span
                ><p-inputnumber
                  class="w-full font-normal"
                  inputStyleClass="h-11 w-full"
                  formControlName="administratorCommissionPercent"
                  mode="decimal"
                  locale="th-TH"
                  suffix=" %"
                  [min]="0"
                  [max]="100"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  placeholder="0"
                />
                @if (
                  tourForm.controls.administratorCommissionPercent.touched &&
                  tourForm.controls.administratorCommissionPercent.invalid
                ) {
                  <small class="font-normal text-red-600">{{
                    tourForm.controls.administratorCommissionPercent.hasError('required')
                      ? 'กรุณาระบุคอมผู้ดูแลทัวร์'
                      : tourForm.controls.administratorCommissionPercent.hasError('max')
                        ? 'คอมผู้ดูแลทัวร์ต้องไม่เกิน 100%'
                        : 'คอมผู้ดูแลทัวร์ต้องไม่ติดลบ'
                  }}</small>
                }
              </label>
            </div>
          </section>
          <section class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 sm:p-5">
            <div
              class="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 pb-3"
            >
              <div class="flex items-center gap-3">
                <span class="grid size-9 place-items-center rounded-lg bg-red-100 text-red-700"
                  ><lucide-icon name="CircleDollarSign" [size]="18" aria-hidden="true"
                /></span>
                <div>
                  <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลค่าใช้จ่าย</h3>
                  <p class="mt-0.5 mb-0 text-xs text-slate-500">
                    เพิ่มรายการค่าใช้จ่ายของทัวร์ได้หลายรายการ
                  </p>
                </div>
              </div>
              <button
                type="button"
                class="tw-button inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-sky-200 bg-white px-4 text-sm font-semibold text-sky-700 transition hover:bg-sky-50 disabled:cursor-not-allowed disabled:opacity-50"
                [disabled]="
                  isLoadingExpenseTypes() || expenseItems.length >= expenseTypeOptions().length
                "
                (click)="addExpenseItem()"
              >
                <lucide-icon name="Plus" [size]="17" aria-hidden="true" />เพิ่มค่าใช้จ่าย
              </button>
            </div>
            @if (isLoadingExpenseTypes()) {
              <p role="status" class="mb-3 text-sm text-slate-500">กำลังโหลดรายการค่าใช้จ่าย...</p>
            } @else if (expenseTypeLoadError()) {
              <div role="alert" class="mb-3 flex flex-wrap items-center gap-2 text-sm text-red-600">
                <span>{{ expenseTypeLoadError() }}</span>
                <button
                  type="button"
                  class="tw-button font-semibold text-sky-700 underline"
                  (click)="loadExpenseTypes()"
                >
                  ลองโหลดอีกครั้ง
                </button>
              </div>
            }
            <div formArrayName="expenses" class="grid gap-3">
              @for (expenseGroup of expenseItems.controls; track expenseGroup; let index = $index) {
                <div
                  [formGroupName]="index"
                  class="grid gap-4 rounded-xl border border-slate-200 bg-white p-4 md:grid-cols-[minmax(0,1fr)_minmax(220px,0.45fr)_auto]"
                >
                  <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                    ><span>รายการค่าใช้จ่าย <span class="text-red-500">*</span></span
                    ><p-select
                      class="w-full font-normal"
                      styleClass="h-11 w-full"
                      formControlName="expenseTypeId"
                      [options]="availableExpenseTypeOptions(index)"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="เลือกรายการค่าใช้จ่าย"
                      appendTo="body"
                    />
                    @if (
                      expenseTypeOptions().length > 0 &&
                      expenseGroup.controls.expenseTypeId.touched &&
                      expenseGroup.controls.expenseTypeId.invalid
                    ) {
                      <small class="font-normal text-red-600">กรุณาเลือกรายการค่าใช้จ่าย</small>
                    }
                  </label>
                  <label class="grid content-start gap-1 text-sm font-semibold text-slate-700"
                    ><span>จำนวนเงิน <span class="text-red-500">*</span></span
                    ><p-inputnumber
                      class="w-full font-normal"
                      inputStyleClass="h-11 w-full"
                      formControlName="amount"
                      mode="currency"
                      currency="THB"
                      locale="th-TH"
                      [min]="0"
                      placeholder="0.00"
                    />
                    @if (
                      expenseGroup.controls.amount.touched && expenseGroup.controls.amount.invalid
                    ) {
                      <small class="font-normal text-red-600">{{
                        expenseGroup.controls.amount.hasError('required')
                          ? 'กรุณาระบุจำนวนเงิน'
                          : 'จำนวนเงินต้องมากกว่า 0 บาท'
                      }}</small>
                    }
                  </label>
                  <div class="flex items-center justify-end">
                    <button
                      type="button"
                      title="ลบรายการค่าใช้จ่าย"
                      class="tw-button inline-flex size-10 items-center justify-center rounded-lg border border-red-200 bg-white text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
                      [disabled]="expenseItems.length === 1"
                      (click)="removeExpenseItem(index)"
                    >
                      <lucide-icon name="Trash2" [size]="17" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              }
              <div class="flex flex-col items-end gap-1">
                <p class="m-0 text-sm font-semibold text-slate-700">
                  ค่าใช้จ่ายรวม
                  <span class="ml-2 text-base font-bold text-emerald-700"
                    >{{ estimatedExpenseTotal() | number: '1.2-2' }} บาท</span
                  >
                </p>
                <span class="min-h-4 text-right">
                  @if (tourForm.hasError('expensesExceedTourTotal')) {
                    <small role="alert" class="font-normal text-red-600">
                      ค่าใช้จ่ายโดยประมาณต้องไม่เกินยอดสุทธิ
                      {{
                        tourForm.controls.tourPrice.value * tourForm.controls.requiredPax.value
                          | number: '1.2-2'
                      }}
                      บาท
                    </small>
                  }
                </span>
              </div>
            </div>
          </section>
        </div>

        <div
          class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
        >
          <button
            type="button"
            class="tw-button rounded-xl border border-slate-300 bg-white px-5 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-100"
            (click)="closeCreateModal()"
          >
            ยกเลิก
          </button>
          <button
            type="submit"
            class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-5 py-2.5 font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)]"
            [disabled]="isSavingTour()"
          >
            <lucide-icon name="Check" [size]="18" aria-hidden="true" />
            {{
              isSavingTour()
                ? 'กำลังบันทึก...'
                : editingTourId()
                  ? 'บันทึกการแก้ไข'
                  : 'บันทึกรายการทัวร์'
            }}
          </button>
        </div>
      </form>
    </section>
  </div>
}

<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #toursTable
    [value]="filteredTours()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '1080px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <label class="relative block w-full max-w-md">
          <lucide-icon
            name="Search"
            [size]="17"
            class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400"
          />
          <input
            pInputText
            class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
            style="padding-left: 2.75rem; border-radius: 0.5rem"
            placeholder="ค้นหาเลขที่ รหัส หรือชื่อทัวร์"
            [value]="searchTerm()"
            (input)="setSearchTerm($event)"
          />
        </label>
        <app-refresh-button
          class="self-end sm:self-auto"
          label="รีเฟรชรายการทัวร์"
          [loading]="isLoadingTours()"
          (refresh)="loadTours()"
        />
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th class="w-32 text-xs whitespace-nowrap">ภาพทัวร์</th>
        <th class="w-44 text-xs whitespace-nowrap">รหัสทัวร์</th>
        <th class="min-w-72 text-xs whitespace-nowrap">ทัวร์และการเดินทาง</th>
        <th class="w-44 text-xs whitespace-nowrap">ประเภท</th>
        <th class="w-44 text-xs whitespace-nowrap">สมาชิก / จำนวนคน</th>
        <th class="w-44 text-xs whitespace-nowrap">สถานะ</th>
        @if (canViewTourActions()) {
          <th class="w-36 text-center text-xs whitespace-nowrap">จัดการ</th>
        }
      </tr>
    </ng-template>

    <ng-template #body let-row>
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/60">
        <td class="py-4 text-center align-middle">
          @if (tourImageUrl(row.profilePath); as imageUrl) {
            <div
              class="mx-auto size-28 min-w-28 overflow-hidden rounded-lg border border-slate-200 bg-slate-100"
            >
              <img
                [src]="imageUrl"
                [alt]="'ภาพทัวร์ ' + row.name"
                width="112"
                height="112"
                loading="lazy"
                class="block h-full w-full object-cover object-center"
              />
            </div>
          } @else {
            <span
              class="mx-auto grid size-28 min-w-28 place-items-center rounded-lg border border-slate-200 bg-slate-100 text-slate-400"
              title="ยังไม่มีภาพทัวร์"
            >
              <lucide-icon name="Image" [size]="20" />
            </span>
          }
        </td>
        <td class="py-4 text-center align-middle">
          <p class="m-0 text-sm font-semibold text-sky-700">
            {{ row.code }}
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">เลขที่ {{ row.tourNo }}</p>
        </td>
        <td class="py-4 text-center align-middle">
          <p class="m-0 text-sm font-semibold leading-5 text-slate-800">{{ row.name }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            {{ row.travelDate | date: 'dd MMM yyyy' }} – {{ row.returnDate | date: 'dd MMM yyyy' }}
          </p>
        </td>
        <td class="py-4 text-center align-middle">
          <app-status-badge [status]="row.type" />
        </td>
        <td class="py-4 text-center align-middle">
          <p class="m-0 text-sm font-semibold text-slate-800">
            {{ row.currentPax }} / {{ row.requiredPax }} คน
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ row.bookingCount }} Booking</p>
        </td>
        <td class="py-4 text-center align-middle">
          <app-status-badge [status]="row.status" />
        </td>
        @if (canViewTourActions()) {
          <td class="py-4 text-center align-middle">
            <div class="flex items-center justify-center gap-1.5">
              <a
                [routerLink]="['/tours', row.id]"
                title="ดูรายละเอียดทัวร์"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 no-underline transition hover:bg-slate-50"
              >
                <lucide-icon name="Eye" [size]="15" />
              </a>
              @if (canManageTours()) {
                <button
                  type="button"
                  [title]="
                    canModifyTour(row) ? 'แก้ไขทัวร์' : 'ทัวร์ที่มีการชำระเงิน แก้ไขได้เฉพาะ Admin'
                  "
                  class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
                  [disabled]="!canModifyTour(row)"
                  (click)="openEditModal(row)"
                >
                  <lucide-icon name="Pencil" [size]="15" />
                </button>
                <button
                  type="button"
                  [title]="canModifyTour(row) ? 'ลบทัวร์' : 'ทัวร์ที่มีการชำระเงิน ลบได้เฉพาะ Admin'"
                  class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-red-200 bg-white text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
                  [disabled]="!canModifyTour(row)"
                  (click)="deleteTour(row)"
                >
                  <lucide-icon name="Trash2" [size]="15" />
                </button>
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="canViewTourActions() ? 7 : 6">
          <div class="empty">
            <b><lucide-icon name="Search" [size]="22" /></b>
            <h3>{{ isLoadingTours() ? 'กำลังโหลดรายการทัวร์' : 'ไม่พบรายการทัวร์' }}</h3>
            <p>{{ isLoadingTours() ? 'กรุณารอสักครู่' : 'ลองเปลี่ยนคำค้นหาหรือตัวกรอง' }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
